module.exports = __webpack_public_path__ + "img/5e537b.dcde568.jpg";